import React from 'react';
import {
  ArrowLeft,
  MoreVertical,
  Copy,
  Archive,
  RotateCcw,
  Share,
} from 'react-feather';
import Dismissable from 'components/shared/dismissable';
import { routes } from 'constants/config';
import { useToggle } from 'hooks';
import { Popover, Button } from 'ui';
import ShareLessonModal from './ShareLessonModal';

const Header = ({ lesson, urls }) => {
  const [dropdownToggle, toggleDropdown] = useToggle();
  const [shareLessonModalToggle, toggleShareLessonModal] = useToggle();
  const isArchived = lesson.archivedAt !== null;
  const showDropdown =
    lesson.permissions.canEditContent ||
    (!lesson.scorm && lesson.permissions.cloneContent);

  return (
    <div className="ff-ss LessonOverviewLayout pt-24">
      <div>
        <a
          href={routes.CONTENT.INDEX}
          className="ws-nw ai-c td-n h-td-u haf-c-lhci c-brand-blue LessonOverviewLayout-backToLessons"
        >
          <ArrowLeft className="mr-8" size={22} />
          <span className="lh-24 fz-16 ff-ss">
            {t('lesson_overview.back_to_content')}
          </span>
        </a>
      </div>
      <div className="Index-header mt-8 mb-16 ai-fs">
        <h1 className="Index-title LessonOverviewLayout-title">
          {lesson.title}
        </h1>
        <div className="d-f mt-12 ai-c LessonOverviewLayout-actionButtons">
          {lesson.permissions.canViewGradebook && (
            <a
              href={urls.gradebook}
              className="ws-nw ml-16 mr-16 lh-24 fz-16 td-n c-brand-blue ff-ss h-td-u haf-c-lhci"
            >
              {t('lesson_overview.view_gradebook')}
            </a>
          )}
          {lesson.permissions.canChangePublicitySettings && (
            <Button
              className="ws-nw ml-16 mr-16"
              onClick={toggleShareLessonModal}
            >
              <span className="d-f ai-c">
                <Share className="mr-8 c-midnight-50" size={16} />
                {t('lesson_overview.share_lesson')}
              </span>
            </Button>
          )}
          <ShareLessonModal
            lesson={lesson}
            urls={urls}
            shown={shareLessonModalToggle}
            toggleModal={toggleShareLessonModal}
          />
          {showDropdown && (
            <Dismissable
              dismissCallback={() => dropdownToggle && toggleDropdown()}
            >
              <Popover
                rootClassName="d-f"
                visible={dropdownToggle}
                align="right"
                onClose={toggleDropdown}
                activator={
                  <button
                    type="button"
                    onClick={toggleDropdown}
                    className="d-f pr-0 pl-0 ml-8 border-0 bs-n bg-inherit"
                  >
                    <MoreVertical className="c-midnight-50" size={22} />
                  </button>
                }
              >
                <div className="mt-10 NewPopover-arrow LessonOverviewLayout-arrow-right" />
                <div className="mt-10 h-ctch-ctc ff-ss ls-n z-10 bg-white LessonOverviewLayout-feather-dropdown-content">
                  {lesson.permissions.cloneContent && !lesson.scorm && (
                    <a
                      aria-label={t('lesson_overview.copy_content')}
                      title={t('lesson_overview.copy_content')}
                      data-behavior="clone_lesson"
                      data-method="post"
                      className="td-n"
                      rel="nofollow"
                      data-remote="true"
                      href={routes.LESSON_OVERVIEW.CLONE_LESSON(lesson.id)}
                    >
                      <li className="p-10 fz-16 d-f ai-c td-n c-p">
                        <Copy
                          className="mr-8 ml-12 mr-12 c-midnight-50"
                          size={20}
                        />
                        {t('lesson_overview.copy_content')}
                      </li>
                    </a>
                  )}
                  {!isArchived && lesson.permissions.canEditContent && (
                    <a
                      aria-label={t('lesson_overview.archive')}
                      title={t('lesson_overview.archive')}
                      data-method="put"
                      className="td-n"
                      rel="nofollow"
                      data-confirm={t('lesson_overview.archive_confirm')}
                      href={routes.LESSON_OVERVIEW.ARCHIVE_LESSON(lesson.id)}
                    >
                      <li className="p-10 fz-16 d-f ai-c td-n c-p">
                        <Archive
                          className="mr-8 ml-12 mr-12 c-midnight-50"
                          size={20}
                        />
                        {t('lesson_overview.archive')}
                      </li>
                    </a>
                  )}
                  {isArchived && lesson.permissions.canEditContent && (
                    <a
                      aria-label={t('lesson_overview.unarchive')}
                      title={t('lesson_overview.unarchive')}
                      data-method="put"
                      className="td-n"
                      rel="nofollow"
                      href={routes.LESSON_OVERVIEW.RESTORE_LESSON(lesson.id)}
                    >
                      <li className="p-10 fz-16 d-f ai-c td-n c-p">
                        <RotateCcw
                          className="mr-8 ml-12 mr-12 c-midnight-50"
                          size={20}
                        />
                        {t('lesson_overview.restore')}
                      </li>
                    </a>
                  )}
                </div>
              </Popover>
            </Dismissable>
          )}
        </div>
      </div>
    </div>
  );
};

export default props => <Header {...props} />;
